import * as React from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import useStyled from "../../hooks/useStyled";

const { styled } = useStyled();

const ButtonGroupStyled = styled(
  ButtonGroup,
  {}
)(({ theme }) => ({
  borderRadius: 30,
  background: "#1A1A2436",
  "& .MuiButton-root": {
    border: 0,
    background: "transparent",
    borderRadius: "30px !important",
    fontSize: 14,
    textTransform: "none",
    borderColor: theme.palette.grey300.main,
    color: theme.palette.grey300.main,
    minWidth: 150,
    "&.active": {
      background: theme.palette.black.main,
      color: theme.palette.white.main,
      border: 0,
    },
    "&:hover": {
      background: theme.palette.black.main,
      color: theme.palette.white.main,
      border: 0,
    },
  },
}));

const SFButtonGroup = ({ items, value, onClick }) => (
  <ButtonGroupStyled size="small">
    {items.map((item) => (
      <Button
        key={item.id}
        className={`${value === item.id ? "active" : ""}`}
        onClick={() => onClick(item)}
      >
        {item.label}
      </Button>
    ))}
  </ButtonGroupStyled>
);

export default SFButtonGroup;
